import { FC, ReactNode } from 'react'

import { Box } from '@mantine/core'

const FeatureCardLeftContent: FC<{ children: ReactNode }> = ({ children }) => {
  return <Box>{children}</Box>
}

FeatureCardLeftContent.displayName = 'FeatureCardLeftContent'

export default FeatureCardLeftContent
